var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconExclamationCircleFillComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'arco';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-exclamation_circle_fill").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 16", fill: useCurrentColor ? 'currentColor' : '#000', xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { d: "M0.66626 7.99996C0.66626 3.94987 3.9495 0.666626 7.99959 0.666626C12.0497 0.666626 15.3329 3.94987 15.3329 7.99996C15.3329 12.05 12.0497 15.3333 7.99959 15.3333C3.9495 15.3333 0.66626 12.05 0.66626 7.99996ZM6.99959 4.33329V8.33329C6.99959 8.51739 7.14883 8.66663 7.33293 8.66663H8.66626C8.85036 8.66663 8.99959 8.51739 8.99959 8.33329V4.33329C8.99959 4.1492 8.85036 3.99996 8.66626 3.99996H7.33293C7.14883 3.99996 6.99959 4.1492 6.99959 4.33329ZM7.99959 12.3333C8.64393 12.3333 9.16626 11.811 9.16626 11.1666C9.16626 10.5223 8.64393 9.99996 7.99959 9.99996C7.35526 9.99996 6.83293 10.5223 6.83293 11.1666C6.83293 11.811 7.35526 12.3333 7.99959 12.3333Z", fillOpacity: "1" }));
}
var IconExclamationCircleFill = React.forwardRef(IconExclamationCircleFillComponent);
export default IconExclamationCircleFill;
